import React, { useRef, useState, useEffect } from 'react'
import styles from './styles.module.scss'
import queryString from 'query-string'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'

function DecryptFile(props) {
  const urlRef = useRef()
  const keyRef = useRef()
  const mimeRef = useRef()
  const [key, setKey] = useState('')
  const [url, setUrl] = useState('')
  const [mime, setMime] = useState('')
  const [result, setResult] = useState('')
  const [processing, setProcessing] = useState(false)
  const decrypt = () => {
    setProcessing(true)
    const urlValue = urlRef.current.value
    const keyValue = keyRef.current.value
    const mimeValue = mimeRef.current.value
    getDescryptedMedia(urlValue, 0, keyValue, mimeValue, 1).then((data) => {
      setResult(data.img)
      setProcessing(false)
    })
  }
  const copyToClipboard = () => {
    navigator.clipboard.writeText(result)
  }

  const downloadFile = () => {
    let a = document.createElement('a')
    a.href = result
    a.setAttribute('download', '')
    document.body.appendChild(a)
    a.click()
    a.parentNode.removeChild(a)
  }

  const openInNewTab = () => {
    if (mime.includes('image')) {
      let image = new Image()
      image.src = result

      let w = window.open('')
      w.document.write(image.outerHTML)
    } else {
      let pdfWindow = window.open('')
      pdfWindow.document.write(`<iframe width='100%' height='100%' src='${result}'></iframe>`)
    }
  }

  useEffect(() => {
    let queryParams = queryString.parse(location.search)
    if (queryParams.key) {
      setKey(queryParams.key)
    }
    if (queryParams.url) {
      setUrl(queryParams.url)
    }
    if (queryParams.mime) {
      setMime(queryParams.mime)
    }
  }, [])

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>File Decryption</h1>
      <h2 className={styles.subTitle}>
        Accepts querystrings: <span>url,key and mime</span>{' '}
      </h2>
      <label>S3 url:</label>{' '}
      <input type='text' ref={urlRef} value={url} onChange={(e) => setUrl(e.target.value.trim())} />
      <label>Key:</label> <input type='text' ref={keyRef} value={key} onChange={(e) => setKey(e.target.value.trim())} />
      <label>
        Mime type: <span> (e.g. image/jpg - default, image/png etc)</span>
      </label>
      <input type='text' ref={mimeRef} value={mime} onChange={(e) => setMime(e.target.value.trim())} />
      <Button handleClick={decrypt} customStyle={styles.decryptButton} text='Decrypt' />
      {processing && <Spinner />}
      <hr className={styles.divider} />
      <div className={styles.resultContainer}>
        <div className={styles.actions}>
          <Button handleClick={downloadFile} text='Download' />
          <Button
            handleClick={openInNewTab}
            customStyle={styles.secondaryButton}
            style='secondary'
            text='Open in new tab'
          />
          <Button
            customStyle={styles.secondaryButton}
            handleClick={copyToClipboard}
            style='secondary'
            text='Copy to clipboard'
          />
        </div>

        <div className={styles.result}>{result}</div>
      </div>
    </div>
  )
}

export default DecryptFile
